export const SECTOR = 'sector';
export const VECTOR = 'vector';
export const MODEL = 'model';
export const OFFICIAL_SECTOR = 'official_sector';
export const OFFICIAL_VECTOR = 'official_vector';
export const SECTOR_OR_VECTOR = 'sector_or_vector';
